module.exports = __webpack_public_path__ + "static/media/Manual.a9ba8963.svg";